module.exports = __webpack_public_path__ + "img/My network-selected-icon.ebaf6207.svg";